import { createAction } from "@reduxjs/toolkit";

import axios from "axios";
import { takeEvery, call, put } from "redux-saga/effects";
import { FETCHING_USER_ACCESS, FETCING_USER_ACCESS_SUCCEEDED, FETCHING_USER_ACCESS_FAILED, FETCHING_STREAM_ACCESS_USERS, FETCHING_STREAM_ACCESS_USERS_SUCCEEDED, FETCHING_STREAM_ACCESS_USERS_FAILED, UPDATING_STREAM_ACCESS, UPDATING_STREAM_ACCESS_SUCCEDDED, UPDATING_STREAM_ACCESS_FAILED, FETCHING_OWNER_STREAMS, FETCHING_OWNER_STREAMS_SUCCEEDED, FETCHING_OWNER_STREAMS_FAILED, SELECT_STREAM_FOR_ACCESS_MANAGEMENT, INVALIDATE_STREAM_ACCESS_USERS } from "./actionTypes";
import { FetchUserAccessFailed, FetchUserAccessRequest, FetchUserAccessResponse, FetchUserManagementListFailed, FetchUserManagementListRequest, FetchUserManagementListResponse, UpdateStreamAccessFailed, UpdateStreamAccessRequest, UpdateStreamAccessResponse } from "../../types/streamAccessControl";

const apiUrl = `${process.env.REACT_APP_API_URL}`;
const STREAMS_BASE_URL = `${apiUrl}/api/2.0/streams`;
const STREAMS_BASE_URL_v1 = `${apiUrl}/api/2.1/streams`;
const STREAMS_BASE_URL_V2 = `${apiUrl}/api/2.2/streams`;

//fetch user access
export const fetchUserAccess = createAction<FetchUserAccessRequest>(FETCHING_USER_ACCESS);

const fetchUserAccessSucceeded = createAction<FetchUserAccessResponse>(FETCING_USER_ACCESS_SUCCEEDED);

const fetchUserAccessFailed = createAction<FetchUserAccessFailed>(FETCHING_USER_ACCESS_FAILED);


const fetchUserAccessSaga = function* (
  action: ReturnType<typeof fetchUserAccess>,
): any {

  const id = action.payload.id;
  const page = action.payload.page;
  const query = action.payload.query;

  const url = new URL(`${STREAMS_BASE_URL}/${id}/access/${page}`);

  let param = {
    query: query
  }

  const fetchUserAccessAPI = () => {
    return axios({
      method: "GET",
      url: url.toString(),
      params: param
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchUserAccessAPI);
    yield put(fetchUserAccessSucceeded(response));
  } catch (error) {
    yield put(fetchUserAccessFailed({id, error}));
  }
};

//fetch stream access users
export const fetchStreamAccessUsers = createAction<FetchUserManagementListRequest>(FETCHING_STREAM_ACCESS_USERS);

const fetchUserAccessUsersSucceeded = createAction<FetchUserManagementListResponse>(FETCHING_STREAM_ACCESS_USERS_SUCCEEDED);

const fetchUserAccessUsersFailed = createAction<FetchUserManagementListFailed>(FETCHING_STREAM_ACCESS_USERS_FAILED);


const fetchStreamAccessUserSaga = function* (
  action: ReturnType<typeof fetchUserAccess>,
): any {
  const id = action.payload.id;
  const page = action.payload.page;
  const query = action.payload.query;

  const url = new URL(`${STREAMS_BASE_URL}/${id}/access/${page}`);

  let param = {
    query: query
  }

  const fetchUserAccessAPI = () => {
    return axios({
      method: "GET",
      url: url.toString(),
      params: param
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchUserAccessAPI);
    yield put(fetchUserAccessUsersSucceeded(response));
  } catch (error) {
    yield put(fetchUserAccessUsersFailed({id, error}));
  }
};

//update stream access
export const updateStreamAccess = createAction<UpdateStreamAccessRequest>(UPDATING_STREAM_ACCESS);

const updatingStreamAccessSucceeded = createAction<UpdateStreamAccessResponse>(UPDATING_STREAM_ACCESS_SUCCEDDED);

const updatingStreamAccessFailed = createAction<UpdateStreamAccessFailed>(UPDATING_STREAM_ACCESS_FAILED);

const updateStreamAccessSaga = function* (
  action: ReturnType<typeof updateStreamAccess>,
): any {

  const id = action.payload.stream.id;
  const stream = action.payload.stream;

  const url = new URL(`${STREAMS_BASE_URL}/${id}/access`);

  const updateStreamAccessAPI = () => {
    return axios({
      method: "PUT",
      url: url.toString(),
      data: stream
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateStreamAccessAPI);
    yield put(updatingStreamAccessSucceeded({id, response}));
  } catch (error) {
    yield put(updatingStreamAccessFailed({id, error}));
  }
};

//fetch owner streams
export const fetchOwnStreams = createAction<any>(FETCHING_OWNER_STREAMS);

const fetchingOwnStreamsSucceeded = createAction<any>(FETCHING_OWNER_STREAMS_SUCCEEDED);

const fetchingOwnStreamsFailed = createAction<any>(FETCHING_OWNER_STREAMS_FAILED);

const fetchOwnStreamsSaga = function* (
  action: ReturnType<typeof fetchOwnStreams>,
): any {

  const url = new URL(`${STREAMS_BASE_URL}/owner`);

  const fetchOwnStreamsAPI = () => {
    return axios({
      method: "GET",
      url: url.toString(),
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchOwnStreamsAPI);
    yield put(fetchingOwnStreamsSucceeded(response));
  } catch (error) {
    yield put(fetchingOwnStreamsFailed({error}));
  }
};

//select stream for access management
export const selectStreamForAccessManagement = createAction<any>(SELECT_STREAM_FOR_ACCESS_MANAGEMENT);

//invalidate streams access user
export const invalidateStreamAccessUsers = createAction(INVALIDATE_STREAM_ACCESS_USERS);

export default function* streamAccessControllerSaga() {
    yield takeEvery(FETCHING_USER_ACCESS, fetchUserAccessSaga);
    yield takeEvery(FETCHING_STREAM_ACCESS_USERS, fetchStreamAccessUserSaga);
    yield takeEvery(UPDATING_STREAM_ACCESS, updateStreamAccessSaga);
    yield takeEvery(FETCHING_OWNER_STREAMS, fetchOwnStreamsSaga);
  }